import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareAiPlanningClassicPlanRoute: InvariantJiraRoute = {
	name: 'software-ai-planning-classic-plan',
	path: '/jira/software/c/projects/:projectKey/ai-planning/:planId',
	exact: true,
};
